<template>
  <div class="programList">
    <div class="search">
      <van-search
          v-model="searchParam"
          :placeholder="$t('append_field.enter_search_keyword')"
          shape="round"
          @search="onSearch"
      >
      </van-search>
    </div>
    <div class="content">
      <van-collapse  accordion>
        <van-swipe-cell :ref="'swipe'+index" v-for="(item,index) in titelData" :key="index" @open="swipe(index)">
          <van-cell :icon="getIcon(item)" :title="item.name"
                    is-link @click="gotoView(item)">
            <template #label>
              <van-icon v-if="item.checkState=='-1'" name="/static/images/icon/verified.png" color="red" />
            </template>
          </van-cell>
          <template slot="right">
            <van-button color="#FF5700" :text="$t('append_field.delete')" style="height: 100%" @click="delTask(item.id)"/>
          </template>
        </van-swipe-cell>
      </van-collapse>
      <van-empty
          v-if="titelData.length === 0"
          class="custom-image"
          image="/static/images/terminal/empty-img.png"
          :description="$t('append_field.data_empty')"
      />
    </div>
    <div class="btns">
      <div >
        <van-button color="#006EFF" size="small" @click="reload">{{$t('append_field.refresh')}}</van-button>
        <span style="display: inline-block;width: 5px"></span>
        <van-button color="#006EFF" size="small" @click="createprogram">{{$t('append_field.createPrograms')}}</van-button>
        <span style="display: inline-block;width: 5px"></span>
      </div>
      <div>
        <van-button color="#FF5700" size="small" @click="allDeleteProgram">{{$t('append_field.clear')}}</van-button>
        <span style="display: inline-block;width: 5px"></span>
      </div>
    </div>
    <van-dialog v-model="dialogShow"
                :title="$t('append_field.createPrograms')" show-cancel-button
                @confirm="onsubmit"
                :beforeClose="vBeforeClose"
                @cancel="inputDialogClose">
      <div class="modal-body" >
       <div>
         <span> {{$t('append_field.program_name')}}</span>
         <van-row style="margin: 10px 0">
           <van-field
               v-model="groupName"
               :placeholder="$t('append_field.enter_program_name')"
               clearable>
           </van-field>
         </van-row>
       </div>
        <div>
          <span>{{$t('append_field.display_type')}}</span>
          <div style="margin: 20px 0">
            <van-radio-group slot="input" v-model="resolutionType" direction="horizontal">
              <van-radio name="2">{{$t('append_field.proportion')}}</van-radio>
              <van-radio name="3">4K</van-radio>
              <van-radio name="1">{{$t('append_field.resolution')}}</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div v-if="resolutionType !=='1'">
          <span> {{ $t('append_field.screen_orientation') }}</span>
          <div style="margin: 20px 0">
            <van-radio-group slot="input" v-model="fixedScreen" direction="horizontal">
              <van-radio name="1">{{$t('append_field.landscape')}}</van-radio>
              <van-radio name="2">{{$t('append_field.portrait')}}</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div  v-if="resolutionType === '1'">
          <div style="display: flex;justify-content: space-between">
            <span> {{ $t('append_field.resolution') }}</span>
             <van-button size="small" type="info" @click="showAddresolution">{{$t('append_field.add_resolution')}}</van-button>
          </div>
          <van-row style="margin: 10px 16px">
          <van-field
              v-model="resolution"
              @click="changeShowResolution"
              readonly
          />
          </van-row>
        </div>

      </div>
    </van-dialog>
    <div v-if="showModal" class="modal-overlay">
      <div class="modal">
        <div class="modal-header">
          <h3 class="modal-title">{{ $t('append_field.program_info') }}</h3>
          <van-button color="#FF5700" size="small" @click="delTask(taskId)">{{ $t('append_field.delete') }}</van-button>
        </div>
        <div class="modal-body">
          <van-row class="">
            <van-col span="12">
             {{$t('append_field.task_name')}}</van-col>
            <van-col span="16">{{taskName}}</van-col>
          </van-row>
          <van-row class="">
            <van-col span="10">
              {{$t('append_field.resolution')}}</van-col>
            <van-col span="16">{{ pmResolution }}</van-col>
          </van-row>
<!--          <van-row class=""  v-if="pmResolutionType!=='1'">
            <van-col span="8">
              {{ $t('append_field.screen_orientation') }}</van-col>
          </van-row>
          <van-row class="row-col-3" v-if="pmResolutionType!=='1'">
            <div class="progremList">
            <van-radio-group slot="input" v-model="pmFixedScreen" direction="horizontal" disabled>
              <van-radio name="1">{{$t('append_field.landscape')}}</van-radio>
              <van-radio name="2">{{$t('append_field.portrait')}}</van-radio>
            </van-radio-group>
            </div>
          </van-row>-->
          <van-row v-if="(level > 0 && roleId == 1)  || roleId > 1  && spPermissions.includes('1')">
            <van-col span="8">
              {{ $t('append_field.program_review') }}
            </van-col>
            <van-button size="small" icon="arrow" @click="showState"></van-button>
          </van-row>
          <van-row class="row-col-3" v-if="spPermissions.includes('1')">
            <div class="progremList">
              <van-radio-group slot="input" v-model="pmState" direction="horizontal" disabled>
                <van-radio name="1">{{ $t('append_field.pass') }}</van-radio>
                <van-radio name="-1">{{ $t('append_field.not_passed_or_not_reviewed') }}</van-radio>
              </van-radio-group>
            </div>
          </van-row>
          <van-row class="">
            <van-col span="8">
              {{$t('append_field.playMode')}}</van-col>
          </van-row>
          <van-row class="row-col-3">
            <div class="progremList">
              <van-radio-group slot="input" v-model="taskPlayMode" direction="horizontal" disabled>
                <van-radio name="1">{{$t('append_field.replaceMode')}}</van-radio>
                <van-radio name="2">{{$t('append_field.appendMode')}}</van-radio>
                <van-radio name="3">{{$t('append_field.apotpatterns')}}</van-radio>
              </van-radio-group>
            </div>
          </van-row>
          <van-row class="">
            <van-col span="8">
              {{$t('append_field.dateRange')}}</van-col>
          </van-row>
          <van-row class="row-col-3">
            <van-col span="11">{{startData}}</van-col>
            <van-col span="1"> ~</van-col>
            <van-col span="12">{{endData}}</van-col>
          </van-row>
          <van-row class="">
            <van-col span="8">
              {{$t('append_field.timeRange')}}</van-col>
          </van-row>
          <van-row class="row-col-3">
            <van-col span="11">{{startTime}}</van-col>
            <van-col span="1"> ~</van-col>
            <van-col span="12">{{endTime}}</van-col>
          </van-row>
          <van-row class="">
            <van-col span="8">
             {{$t('append_field.taskPeriod')}}</van-col>
          </van-row>
          <van-row class="weekliWrap">
            <div class="weekli" :class="taskDetailData['etMon'] === 'false' ? '': 'active'">{{$t('append_field.mon')}}</div>
            <div class="weekli" :class="taskDetailData['etTue'] === 'false' ? '': 'active'">{{$t('append_field.tue')}}</div>
            <div class="weekli" :class="taskDetailData['etWed'] === 'false' ? '': 'active'">{{$t('append_field.wed')}}</div>
            <div class="weekli" :class="taskDetailData['etThur'] === 'false' ? '': 'active'">{{$t('append_field.thu')}}</div>
            <div class="weekli" :class="taskDetailData['etFri'] === 'false' ? '': 'active'">{{$t('append_field.fri')}}</div>
            <div class="weekli" :class="taskDetailData['etSat'] === 'false' ? '': 'active'">{{$t('append_field.sat')}}</div>
            <div class="weekli" :class="taskDetailData['etSun'] === 'false' ? '': 'active'">{{$t('append_field.sun')}}</div>
          </van-row>
            <!-- 其他不可编辑的字段 -->
        </div>
        <div class="modal-footer">
          <van-button style="color: black;border-top: 1px solid #B8B8B8;border-right: 1px solid #707070;"  @click="showModal=false">{{ $t('append_field.close') }}</van-button>
          <van-button style="color: #409eff;border-top: 1px solid #B8B8B8;border-right: 1px solid #707070;" @click="gotoa(`/createProrram`,{
                      id: programId,
                      type: 'edit',
                      taskDetailData: [taskDetailData]
                      })"> {{ $t('append_field.edit') }}</van-button>
          <van-button style="color: #409eff;border-top: 1px solid #B8B8B8;"   @click="showDeviceList"> {{ $t('append_field.send') }}</van-button>
        </div>
      </div>
    </div>
    <van-popup v-model="showResolution" position="bottom" >
      <van-search
          v-model="searchQuery"

          :placeholder="$t('append_field.enter_search_keyword')"
          @search="onSearchResolution"
      />
      <van-picker
          v-if="filteredResolutions.length"
          show-toolbar
          :columns="filteredResolutions"
          :title="$t('append_field.resolution_list')"
          @cancel="showResolution = false"
          @confirm="getResolution"
      />
      <div v-else class="empty-state">
        {{ $t('append_field.no_data') }}
      </div>
    </van-popup>
    <van-dialog v-model="addShowResolution"
                :title="$t('append_field.add_resolution')"
                @confirm="addResolution"
                show-cancel-button
                :beforeClose="vBeforeClose"
                @cancel="resolutionDialogClose">
        <div class="modal-body">
          <div>
            <span> {{ $t('append_field.width') }}</span>
            <van-row style="margin: 10px 16px">
              <van-field
                  v-model="width"
                  type="number"
                  :placeholder="$t('append_field.enter_width')"
                  @blur="requiredW"
                  :error-message="errorW"
                  clearable
              />
            </van-row>
          </div>
          <div>
            <span> {{ $t('append_field.height') }}</span>
            <van-row style="margin: 10px 16px">
              <van-field
                  v-model="height"
                  type="number"
                  :placeholder="$t('append_field.enter_height')"
                  @blur="requiredH"
                  :error-message="errorH"
                  clearable
              />
            </van-row>
          </div>

        </div>
    </van-dialog>
    <van-dialog v-model="dialogShowState"
                :title="$t('append_field.program_review')"
                show-cancel-button
                @confirm="changeState"
                class="status-dialog"
                :beforeClose="vBeforeClose"
                @cancel="inputDialogClose">
      <div style="margin:20px " >
        <van-row style="margin:10px 0 ">
          <van-col span="18">
            {{$t('append_field.review_status')}}</van-col>
        </van-row>
        <van-row class="row-col-3">
          <div class="progremList">
            <van-radio-group v-model="from.state" direction="horizontal">
              <van-radio name="1">{{ $t('append_field.pass') }}</van-radio>
              <van-radio name="-1">{{ $t('append_field.reject') }}</van-radio>
            </van-radio-group>
          </div>
        </van-row>
        <van-row style="margin:10px 0 " v-if="from.state == '-1'">
          <van-col span="18">
            {{$t('append_field.review_content')}}</van-col>
        </van-row>
        <van-row class="row-col-3">
          <div class="progremList">
            <van-field
                v-if="from.state == '-1'"
                v-model="reason"
                :placeholder="$t('append_field.enter_review_content')"
            />
          </div>
        </van-row>
      </div>

    </van-dialog>

    <!--  设备列表弹窗  -->
    <van-dialog v-model="dialogDeviceList"
                class="device-list"
                :title="$t('append_field.deviceList')"
                show-cancel-button
                @confirm="confirmSend"
                :beforeClose="vBeforeClose"
                @cancel="closeDeviceList"
    >
      <div class="main">
        <div class="btn-list" >
          <van-button v-for="(item, index) in terminalMenuItems"
                      :key="index" :name="index"
                      :class="['terminal-btn', { 'selected': selectedIndex === index }]"
                      icon="/static/images/etv-folder.png"
                      @click="loadDeviceList(index)">
            {{ truncatedName(item.name) }}
          </van-button>
        </div>
        <div class="btn-state">
          <van-radio-group  v-model="state" @change="onSearchTerinalList" direction="horizontal">
            <span style="margin-right: 8px;display: flex;align-items: center">{{$t('append_field.terminal_status')}}：</span>
            <van-radio name="0">{{ $t('append_field.all') }}</van-radio>
            <van-radio name="1">{{ $t('append_field.online') }}</van-radio>
            <van-radio name="-1">{{ $t('append_field.offline') }}</van-radio>
          </van-radio-group>
        </div>
        <div class="btn-select">
          <span>{{ $t('append_field.select_all') }}：</span>
          <van-checkbox
              v-model="isCheckAll"
              :indeterminate="isIndeterminate"
              @click="checkAllChange()"
          >

          </van-checkbox>
        </div>
        <van-search
            v-model="clientName"
            :placeholder="$t('append_field.enter_search_keyword')"
            shape="round"
            @search="onSearchTerinalList"
        >
        </van-search>

        <div class="scroll-m-li " ref="scrollContainer">
          <van-checkbox-group v-model="terminalSelect" @change="checkedResultChange()" v-if="data_m.length > 0">
            <div v-for="(item, index) in data_m"
                 :key="index"
                 class="custom-checkbox">
              <van-cell class="checkbox-content"
                        @click="toggleCheckbox(item)"
                        :icon="item.onlineState == '1' ? '/static/images/terminal/icon_dev_online.png' : '/static/images/terminal/icon_dev_disonline.png'">
                <span class="ellipsis">{{ item.name }}</span>
              </van-cell>
              <van-checkbox :class="'checkboxes-'+index" :name="item.clNo+'-'+item.clId"  />
            </div>
          </van-checkbox-group>
          <van-empty
              v-else
              class="custom-image"
              image="/static/images/terminal/empty-img.png"
              :description="$t('append_field.data_empty')"
          />
        </div>
      </div>

    </van-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import {Dialog, Toast} from 'vant'
import {mapActions} from 'vuex'
import {vBeforeClose} from "@/utils/tool";

export default {
  name: 'programList',
  inject: ['reload'],
  data() {
    return {
      activeNames: '',
      data: [],
      titelData: [],
      dialogShow: false,
      groupName: `task-${new Date().getFullYear()}${new Date().getMonth() + 1}${new Date().getDate()}${new Date().getHours()}${new Date().getMinutes() + 1}${new Date().getSeconds()}`,
      onlineState: '',
      programShow: false,
      value: '',
      resolutionType: "2",
      fixedScreen: "1",
      startTime: '00:00:00',
      endTime: '23:59:00',
      startData: '',
      endData: '',
      showModal:false,
      taskPlayMode: '',
      taskType: '',
      taskId:'',
      taskName:'',
      taskDataRange:'',
      taskTimeRange: '',
      taskCycle: '',
      taskDetailData: {},
      pmList: [],
      pmFixedScreen:"1", // 1横屏  2竖屏
      pmResolutionType:'2', // 1 自定义分辨率 2 比例 3 4K
      pmResolution: '', // 分辨率 1920*1080等
      programId:'',
      resolution:'',
      searchParam:'',
      showResolution:false,
      resolutions:[],
      addShowResolution:false,
      //添加分辨率
      height: '',
      width: '',
      errorH: '',
      errorW: '',
      filteredResolutions: [],
      searchQuery:'',
      pmState:'1'  ,//审核状态  1 通过  -1 未通过 0 待审核
      dialogShowState:false,
      reason:'',  //审核不通过原因
      pmId:'',
      from:{
        state:'1',
        reason:'',
        pmId:'',
      },
      dialogDeviceList:false, //设备列表弹窗
      terminalMenuItems: [],  //设备列表
      terminalSelect: [],
      selectedIndex: 0,
      state: '0',
      clientName:'',
      data_m: [], // 当前显示的数据
      allData: [], // 所有设备的数据
      index: 0, // 滚动加载的索引
      isCheckAll:false,
      isIndeterminate:false,
      spPermissions:null,
      level:null,
      roleId:null
    }
  },
  watch: {
    searchQuery(newQuery) {
      if(newQuery===''){
        this.filteredResolutions = this.resolutions.map(res => `${res.ruLPixel}*${res.ruWPixel}`)
      }else {
        this.filteredResolutions = this.resolutions
            .map(res => `${res.ruLPixel}*${res.ruWPixel}`)
            .filter(res => res.includes(newQuery))
      }

    },
    'form.state': function(newVal) {
      if (newVal === '1') {
        this.form.reason = ""; // 清空输入框内容
      }
    }
  },
  mounted() {
    this.level=Number(localStorage.getItem('level'))
    this.roleId=Number(localStorage.getItem('roleId'))
    this.spPermissions=localStorage.getItem('spPermissions')
    this.getData()

  },
  methods: {
    swipe(index){
      const data = this.titelData
      data.forEach((d,i)=>{
        if(i!==index){
          const str = `swipe${i}`
          this.$refs[str][0].close()
        }
      })
    },
    vBeforeClose,
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
    /*
    * 获取任务列表
    * */
    getData() {
      this.$ajax.post('/etv/selectPhoneEqTaskList.json').then(res => {
        if(res.data.data.children[0]&& res.data.data.children[0].children.length !== 0){
          this.titelData = this.getLeafNodes(res.data.data.children)
        }


      })
    },
    /*
    * 递归遍历节点
    * */
    getLeafNodes(children) {
      let leafNodes = []
      function findLeaves(nodes) {
        nodes.forEach(node => {
          if (node.children && node.children.length > 0) {
            findLeaves(node.children)
          } else if(!node.children){
            leafNodes.push(node)
          }
        })
      }

      findLeaves(children)
      return leafNodes
    },
    deleTer(clNo, index) {
      Dialog.confirm({
        title: this.$t('append_field.deleteP'),
        message: this.$t('append_field.con_P'),
      }).then(() => {
        this.$ajax.post('/etv/deleteClientByClNo.json', qs.stringify({
          clNos: clNo,
        })).then(res => {
          if (res.data.code === 0) {
            Toast(this.$t('append_field.delete_success'))
            this.data.splice(index, 1)
          }
        })
      }).catch(() => {

      })
    },
    getIcon(item) {
      switch (item.type) {
        case '1':
          return '/static/images/program/tiHuan.png';
        case '2':
          return '/static/images/program/zhuiJia.png';
        case '3':
          return '/static/images/chaBo.png';
          // 添加更多类型和对应的图标路径
        default:
          return '/static/images/sync.png';
      }
    },
    gotoView(data) {
      this.getBaseInfo(data.id)
      this.$nextTick(() => {
        this.showModal=true
      })

    },
    getBaseInfo(taskId) {
      this.$ajax.post('/etv/selectEquipmentTaskById.json', qs.stringify({
        id: taskId
      })).then(res => {
        this.taskId=taskId
        this.taskName = res.data.data.etName
        this.startData = res.data.data.etStartDate
        this.endData = res.data.data.etEndDate
        this.startTime = res.data.data.etStartTime
        this.endTime = res.data.data.etEndTime
        this.taskDataRange = res.data.data.etStartDate + '~' + res.data.data.etEndDate
        this.taskTimeRange = res.data.data.etStartTime + '~' + res.data.data.etEndTime
        //播放模式：替换模式——etPlayMode=1，追加模式——etPlayMode=2
        this.taskPlayMode = res.data.data.etLevel
        this.taskDetailData = res.data.data
        this.pmFixedScreen=JSON.stringify(res.data.data.pmList[0].pmFixedScreen)
        this.pmResolutionType=JSON.stringify(res.data.data.pmList[0].pmResolutionType)
        this.pmResolution=res.data.data.pmList[0].pmResolution
        this.pmList = res.data.data.pmList
        this.pmState=res.data.data.pmList[0].pmState
        this.programId=res.data.data.pmList[0].id
      })
    },
    delTask(id) {
      Dialog.confirm({
        title: this.$t('append_field.deleteP')
        , message: this.$t('append_field.confirm_delete_this_program'),
      }).then(() => {
        this.$ajax.post('/etv/deleteEquipmentTask.json', qs.stringify({
          id:id,
          type: 'task',
        })).then(res => {
          if (res.data.code === 0) {
            Toast(this.$t('append_field.delete_success'),'success')
            this.reload()
          } else {
            Toast(res.data.msg)
          }
        })
      }).catch(() => {
      })

    },

    inputDialogClose() {
      this.dialogShow = false
      this.programShow = false
      /*this.groupName = ''
      this.resolution = ''*/
      this.dialogShowState=false
      this.reason=''
    },

    onsubmit() {
      let now = new Date()
      let nextYear = new Date(new Date().setFullYear(now.getFullYear() + 1))
      // 使用内置的函数和模板字符串来格式化日期
      let formatDate = (date) => {
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        // PadStart会添加前导零如果需要的话
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      }
      // 设置开始和结束日期
      this.startData = formatDate(now)
      this.endData = formatDate(nextYear)
      if(!this.groupName){
        Toast(this.$t('append_field.name_cannot_be_empty'),'fail')
        return
      }
      let baseResolution = this.fixedScreen === '1' ? '1920*1080' : '1080*1920'

      if (this.resolutionType === '3') {
        const [width, height] = baseResolution.split('*').map(Number)
        baseResolution = `${width * 2}*${height * 2}`
        this.resolution = baseResolution
      }else if(this.resolutionType === '2'){
        this.resolution = baseResolution
      }
      if(this.groupName.length > 50){
        Toast(this.$t('append_field.nameLengthLimit'),'fail')
        return
      }

      this.$ajax.post('/etv/insertPhoneProgramMouldInfo.json', qs.stringify({
        name: this.groupName,
        pcId:'1',
        resolutionType: this.resolutionType,
        fixedScreen: this.fixedScreen,
        resolution:this.resolution,
        taskName:this.groupName,
        level:'1',
        ecId:'',
        disPlayNo:'',
        playMode:'1',
        mon:'true',
        tue:'true',
        wed:'true',
        thur:'true',
        fri:'true',
        sat:'true',
        sun:'true',
        startTime:this.startTime,
        endTime:this.endTime,
        startDate:this.startData,
        endDate: this.endData,
        taskType: '1'
      })).then(res => {
        if (res.data.code === 0) {
          this.gotoa(
              '/createProrram',
              {
                id: res.data.data.pmId,
                type: 'add',
                taskId: res.data.data.ceEtId,
                taskName:this.groupName
              }
          )
         /* this.gotoEditProgram(res.data.data.pmId)*/
        } else {
          Toast(res.data.msg)
        }
      })
    },

    createprogram() {
      this.$ajax.post('/etv/selectAllResolution.json').then(res => {
        if (res.data.code === 0) {
          this.resolutions = res.data.data
          this.resolution = res.data.data[0].ruLPixel + '*' + res.data.data[0].ruWPixel
        }
      })
      this.dialogShow=true
      this.groupName=`task-${new Date().getFullYear()}${new Date().getMonth() + 1}${new Date().getDate()}${new Date().getHours()}${new Date().getMinutes() + 1}${new Date().getSeconds()}`
    },
    allDeleteProgram() {
      Dialog.confirm({
        title: this.$t('append_field.clear')
        , message: this.$t('append_field.del_Null_Program'),
      }).then(() => {
        this.$ajax.post('/etv/clearPhoneTask.json').then(res => {
          if (res.data.code === 0) {
            Toast(this.$t('append_field.delete_success'))
            this.getData()
          }
          Toast(res.data.msg)
        })
      }).catch(() => {
      })
    },
    gotoEditProgram(programId){
      this.$router.push({
        path: `/createProrram`,
        query: {
          id: programId,
          type: 'edit'
        }
      })
    },
    gotoa(url, query) {
      this.$router.push({
        path: url,
        query,

      })
      if (url == '/addTask') {
        this.changeTopTitle(this.$t('append_field.addTask'))
        this.setParentPage('programs')
        this.changeTopIconStatus(true)
      }
    },
    onSearch(){
      this.$ajax.post('/etv/searchTasks.json', qs.stringify({
        searchParam:this.searchParam,
      })).then(res => {
        if (res.data.code === 0) {
            this.titelData = this.getLeafNodes(res.data.data.children)
        } else {
          Toast(res.data.msg)
        }
      })
    },
    changeShowResolution(){
      this.searchQuery=''
      this.showResolution = true
      this.filteredResolutions = this.resolutions.map(res => `${res.ruLPixel}*${res.ruWPixel}`)
    },
    getResolution(value) {
      this.showResolution = false
      this.resolution = value
    },
    showAddresolution(){
      this.height=''
      this.width=''
      this.addShowResolution=true
    },
    resolutionDialogClose(){
      this.addShowResolution=false
    },
    requiredW() {
      if (this.width === '' || parseInt(this.width) <= 299 || parseInt(this.width) >= 8001) {
        this.errorW = this.$t('append_field.enter_number_between_300_to_8000')
      } else {
        this.errorW = ''
      }
    },
    requiredH() {
      if (this.height === '' ||parseInt(this.height) <= 299 || parseInt(this.height) >= 8001) {
        this.errorH = this.$t('append_field.enter_number_between_300_to_8000')
      } else {
        this.errorH = ''
      }
    },
    removeLeadingZeros(num) {
      const str = String(num);
      const result = str.replace(/^0+/, '');
      return result === '' ? 0 : parseInt(result);
    },
    addResolution(){
      const w = this.removeLeadingZeros(this.width)
      const h = this.removeLeadingZeros(this.height)
      if (!w || !h) {
        Toast(this.$t('append_field.height_width_cannot_be_empty'))
        return;
      }
      if (w <= 299 || w >= 8001) {
        Toast(this.$t('append_field.enter_number_between_300_to_8000'))
        return;
      }
      if (h <= 299 || h >= 8001) {
        Toast(this.$t('append_field.enter_number_between_300_to_8000'))
        return;
      }
      this.$ajax.post('/etv/insertResolution.json', qs.stringify({
        ruLPixel: w,
        ruWPixel: h,
      })).then(res => {
        if (res.data.code === 0) {
          this.createprogram()
          Toast(this.$t('append_field.add_success'))
          this.addShowResolution=false
        } else {
          Toast(res.data.msg)
        }
      })
    },
    onSearchResolution(value) {
      this.searchQuery = value;
    },
    showState(){

      this.$nextTick(() => {
        this.selectState()
      })
      this.from={
        pmId:this.programId,
        state:this.pmState,
      }
      this.dialogShowState=true
    },
    ///selectVerify.json
    selectState(){
      this.$ajax.post('/etv/selectVerify.json', qs.stringify({
        pmId:this.programId
      })).then(res => {
        if (res.data.code === 0) {
          this.reason = res.data.data.reason
        }
      })
    },
    changeState(){
      if(this.from.state =='-1' && (this.reason=='' || this.reason==undefined)){
        Toast(this.$t('append_field.enter_review_content'))
        return
      }
      this.$ajax.post('/etv/insertVerify.json', qs.stringify({
        reason: this.reason,
        pmId: this.from.pmId,
        state: this.from.state,
      })).then(res => {
        if(res.data.code===0){
          Toast(res.data.msg)
          this.dialogShowState=false
          this.showModal=false
          this.getData()
        }else {
          Toast(res.data.msg)
        }

      })
    },
    /*
    * 设备列表的方法
    * */
    // 显示设备列表
    showDeviceList() {
      this.getTerinalList()
      this.dialogDeviceList = true
      this.state='0'
      this.clientName=''
    },

    // 全选/取消全选
    checkAllChange() {
      if (this.isCheckAll) {
        this.terminalSelect = this.allData.map(item => `${item.clNo}-${item.clId}`)
      } else {
        this.terminalSelect = []
      }
      this.updateIndeterminateState()
    },

    // 复选框组状态变化时调用
    checkedResultChange() {
      this.updateIndeterminateState()
    },

    // 更新不确定状态
    updateIndeterminateState() {
      //需要显示设备列表时才执行
      if(this.allData.length===0) return
      const totalItems = this.allData.length
      const checkedItems = this.terminalSelect.length
      this.isCheckAll = checkedItems === totalItems
      this.isIndeterminate = checkedItems > 0 && checkedItems < totalItems
    },

    // 切换复选框状态
    toggleCheckbox(item) {
      const name = `${item.clNo}-${item.clId}`
      const index = this.terminalSelect.indexOf(name)
      if (index > -1) {
        this.terminalSelect.splice(index, 1)
      } else {
        this.terminalSelect.push(name)
      }
      this.updateIndeterminateState()
    },

    // 检查复选框是否被选中
    isChecked(item) {
      const name = `${item.clNo}-${item.clId}`
      return this.terminalSelect.includes(name)
    },
    closeDeviceList(){
      this.terminalSelect = [] // 清空选择\
    },
    onSearchTerinalList() {
      this.getTerinalList(this.state,this.clientName)
      this.show = false
    },
    getTerinalList(onlineState = '', clientName = '', groupParentId = '', type = '') {
      /*切换的时候需要重新定义全选的状态*/
      this.isCheckAll=false
      this.terminalSelect=[]
      this.$ajax.post('/etv/selectSeachClientTreeMobile.json',qs.stringify({
        groupParentId,
        type,
        onlineState,
        clientName,
      })).then(res => {
        let arr = res.data.data;
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          arr2.push({ name: arr[i].name, value: arr[i].id, children: arr[i].children });
        }
        this.terminalMenuItems = arr2;
        this.dialogDeviceList = true;
        // 默认加载第一个按钮的设备列表
        if (this.terminalMenuItems.length > 0) {
          this.loadDeviceList(0)
        }else {
          this.data_m=[]
        }

        // 使用 Vue.nextTick 确保 DOM 已经更新
        this.$nextTick(() => {
          const Terminal = this.$refs.scrollContainer;
          if (Terminal) {
            Terminal.addEventListener('scroll', this.handleScroll2);
          }
        });
      });
    },
    loadDeviceList(index) {
      this.isCheckAll=false

      this.terminalSelect=[]
      this.activeNames = index
      this.index = 0
      this.data_m = this.terminalMenuItems[index].children.slice(0, 10)// 默认加载前10条数据
      this.allData = this.terminalMenuItems[index].children // 所有数据
      this.selectedIndex = index
      //重置滚动位置
      this.$nextTick(() => {
        this.$refs.scrollContainer.scrollTop = 0
      });

    },
    truncatedName(fullName) {
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0]
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : ''
      if (namePart.length  <= 4) {
        return fullName
      } else {
        return `${namePart.substring(0, 4)}...${infoPart}`
      }
    },
    //滚动事件
    handleScroll2() {
      const scrollContainer = this.$refs.scrollContainer
      if (!scrollContainer) return;

      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;
      const scrollTop = scrollContainer.scrollTop;
      const scrollOffset = 40; // Adjust this value as needed

      if (clientHeight + scrollTop + scrollOffset >= scrollHeight) {
        const children = this.terminalMenuItems[this.activeNames].children;
        if (children.slice(this.index * 10, this.index * 10 + 10).length < 10) {
          return;
        }
        this.index++;
        this.data_m = [...new Set([...this.data_m, ...children.slice(this.index * 10, this.index * 10 + 10)])];
      }
    },

    //设备列表
    confirmSend() {
      if (this.terminalSelect.length == 0) {
        Toast(this.$t('append_field.selectDevice'))
        return
      }
      let _this = this
      let postData = {
        ceEtId: _this.taskId,
        clientNos: '',
        ids: '',
      }
      let terminalSelectedArr = _this.terminalSelect
      let noArr = [], idArr = []
      for (var i = 0; i < terminalSelectedArr.length; i++) {
        idArr.push(terminalSelectedArr[i].split('-')[1])
        noArr.push(terminalSelectedArr[i].split('-')[0])
      }
      postData.clientNos = noArr.join(',')
      postData.ids = idArr.join(',')
      this.$ajax.post('/etv/insertClientEqTask.json', qs.stringify(postData)).then(res => {
        if (res.data.code == 0) {
          _this.dialogDeviceList=false
          _this.showModal=false
          _this.terminalSelect = []
          _this.activeNames = ['1']
          _this.taskId = ''
          Toast(this.$t('append_field.sendTaskSuccess'))
          this.$router.push({path: '/programs', query: {itemName: 'c'}})
              .then(() => {
                // 强制刷新
                this.reload()
              })

        } else {
          Toast(res.data.msg)
        }


      })
    },
  },

}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.programList {
  .search{
    height: 55px;
  }
  .content {
    overflow-y: auto;
    .van-cell__title{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      span{
        width: 100%; /* 使文本占满按钮宽度 */
        white-space: nowrap; /* 确保文本在一行显示 */
        overflow: hidden; /* 超出容器部分隐藏 */
        text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
      }
    }
    .van-icon__image{
      height: 1.5em;
      width: 1.5em;
    }
    .van-collapse-item__title--expanded {
      background: $uni-color-primary;
      color: #ffffff;

      .van-cell__right-icon {
        color: white;
      }
    }

    .van-collapse-item__content {
      padding: 0;
    }

    .item-child {
      list-style: none;
      padding: 0 16px;

      li {
        padding: 10px 0;
        line-height: 30px;
        position: relative;
        display: flex;
        justify-content: space-between;

        button {
          line-height: 22px;
        }

        img {
          height: 24px;
          margin-right: 10px;
        }

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: 1px solid $uni-border-bottom-color;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

      li:nth-last-child(1) {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: none;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

    }
  }

  .btns {
    display: flex;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background: #FFFFFF;
  }

  .a {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .popup-title {
    height: 30px;
    line-height: 30px;
    background: #ffffff;
    padding-left: 15px;
  }

  .popup-btns {
    margin-top: 15px;
    padding: 0 15px;
  }

  .button-btns {
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .van-cell{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .van-cell__title {
    line-height: 30px !important;
    font-size: 16px;
    white-space: nowrap; /* 确保文本在一行显示 */
    overflow: hidden; /* 超出容器部分隐藏 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
 /*   .van-cell__right-icon {
      line-height: 30px;
    }*/
  }

/*  .van-cell__left-icon {
    font-size: 25px !important;
    line-height: 30px;
  }*/
  .van-button--mini{
    line-height: 30px;
  }

  .modal-overlay {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 70px);
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
  }

  .modal {
    background: #fff;
    border-radius: 4px ;
    width: 100%;
    position: fixed;

  }

  .modal-header {
    display: flex;
    padding: 8px 20px ;
    justify-content: space-between;
    align-items: center;
    background: #F2F2F2 !important;
  }

  .modal-title {
    margin: 0;
    font-weight: 600;
    font-size: 18px;
  }

  .delete-button {
    background: none;
    border: none;
    color: red;
    cursor: pointer;
  }

  .modal-body {
    margin:20px;
    max-height: 400px;
    overflow-y: auto;
    .van-row {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #ebedf0;
      align-items: center;
      display: flex;
      justify-content: flex-start;
      .van-button--default{
        border: 1px solid #ffffff;
      }
      .van-col--8 {
        width: 100%;
        color: #323233;

      }

      .van-col--16 {
        text-align: right;
        white-space: nowrap; /* 确保文本在一行显示 */
        overflow: hidden; /* 超出容器部分隐藏 */
        text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
        color: #323233;
      }

      .van-icon-location-o:before {
        content: '';
      }

      .van-icon-location-o {
        margin: 4px 6px 0 0;
        width: 16px;
        height: 16px;
        color: #006EFF;
        background: #006EFF;
        border-radius: 50%;
        line-height: 10px;
      }

      &.row-col-3 {
        justify-content: space-between;
        .van-col {
          display: flex;
          justify-content: center;
          color: #323233;
        }
        .progremList{
          display: flex;
          align-items: center;
        /*  justify-content: center;*/
          overflow-y: auto;
          .van-radio-group--horizontal{
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
          }
          .van-radio--horizontal{
            margin-right: 5px;
          }
        }
      }

      &.weekliWrap {
        display: flex;
        justify-content: space-around;
        height: 48px;

        .weekli {
          margin-top: 4px;
          width: 40px;
          height: 40px;
          background: #fff;
          border: 1px solid #006EFF;
          color: #006EFF;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .weekli.active {
          background: #006EFF;
          color: #fff;
        }


      }
      .van-cell{
        font-size: 18px !important;
      }
    }

  }

  .form-group {
    margin-bottom: 15px;
  }

  .form-group label {
    display: block;
    margin-bottom: 5px;
  }

  .form-group input {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
  }

  .modal-footer {
    display: flex;
    justify-content: space-between;

    background: #F2F2F2 ;
    .van-button {
      height: 48px !important;
      background: #F2F2F2 ;
      border-radius: 0 !important;
      flex: 1;
    }
  }

  .add-resolution{
    margin: 40px 10px;
    .van-cell{
      margin-bottom: 20px;
    }
  }

  .empty-state {
    text-align: center;
    padding: 143px 0;
    color: #999;
  }
  .status-dialog{
    z-index: 2;
    .progremList{
      display: flex;
      align-items: center;
      .van-radio-group--horizontal{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
      }
      .van-radio--horizontal{
        margin-right: 40px;
      }
    }
  }
  .device-list{
    display: flex;
    flex-direction: column;
    .main{
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .btn-list{
      display: flex;
      overflow-y: auto;
      align-items: center;
      justify-content: flex-start;
      gap: 10px; /* 按钮之间的间隔 */
      margin:  10px 10px;

      .terminal-btn{
        flex: 1 1 auto; /* 自适应宽度 */
        white-space: nowrap; /* 防止文字换行 */
        background-color: white;
        color: black;
        border: 1px solid #ddd; /* 可选：添加边框以便更清晰地看到按钮 */
        .van-button__text{
          max-width: 100%;
        }
      }
      .selected {
        background-color: #006EFF ;
        color: white;
      }
    }
    .btn-state{

      overflow-y: auto;
      padding: 5px 12px;
      .van-radio-group--horizontal{
        overflow-y: auto;
        display: flex;
        flex-wrap: nowrap
      }
    }
    .btn-select{
      display: flex;
      align-items: center;
      padding: 5px 12px;
      span{
      padding-right: 10px;
      }
    }
    .scroll-m-li {
      height: 300px;
      display: flex;
      overflow-y: auto;
      margin: 0 20px;
      .van-cell__value--alone{
        margin-left: 10px;
      }
      .van-checkbox{
        overflow: initial;
      }
      .van-icon{
        width: 1.5em;
        height: 1.5em;
      }
      .van-checkbox-group{
        width: 100%;
      }
      .custom-checkbox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
      }

      .checkbox-content {
        display: flex;
        align-items: center;
        .ellipsis {
          display: block;
          max-width: 200px; /* 根据需要调整宽度 */
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          vertical-align: top; /* 确保文本对齐 */
        }
        .van-cell__left-icon{
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .van-icon__image{
          width: 40px;
          height: 40px;
        }
      }

    }
  }
}
</style>
